import React from 'react';
import { Row, Col, Card } from 'react-bootstrap';
import TimelineProspectos from './TimelineProspectos';
import GraficoCorretores from './GraficoCorretores';

export default function SecaoImobiliaria({ imobiliaria, isPesquisa, index }) {
  if (!imobiliaria) return null;

  return (
    <Card className="mb-3 shadow-sm" style={{ border: '1px solid #a8a4a4' }}>
      <Card.Body className="py-2 px-2">
        <Row className="mb-2">
          <Col xs={12} md={2} className="text-center d-flex align-items-center justify-content-center">
            {imobiliaria.url_logo && (
              <img
                src={imobiliaria.url_logo}
                alt="Logo Imobiliaria"
                style={{ maxWidth: '100%', maxHeight: '80px' }}
              />
            )}
          </Col>
          <Col xs={12} md={10}>
            <TimelineProspectos
              dados={imobiliaria.timeline}
              isPesquisa={isPesquisa}
              principal={false}
            />
          </Col>
        </Row>

        {imobiliaria.corretores && imobiliaria.corretores.length > 0 && (
          <GraficoCorretores
            corretores={imobiliaria.corretores}
            isPesquisa={isPesquisa}
            index={index}
          />
        )}
      </Card.Body>
    </Card>
  );
}
